import React, {Fragment} from "react";
import {ButtonStatus} from "../../components/button/enum";
import Button from "../../components/button/button";
import {$iconBirthday, $iconCalendar, $iconPostAppointment} from "../../assets/icons";
import {AutomatedCampaignType, CampaignBigType} from "./dataForActiveCampaign";
import ToolTips, {ToolTipAlign, ToolTipPosition} from "../../components/toolTips/toolTips";
import {MaxAppointmentReminderCount, MaxBirthdayReminderCount} from "./campaignList";

export interface SubCampaignTypeItem {
    title: string,
    description: string,
    type: AutomatedCampaignType,
    icon?: any
}

export interface CampaignBigTypeItem {
    title: string,
    description: string,
    bigType: CampaignBigType,
    subTypeItems?: Array<SubCampaignTypeItem>
}

interface IProps {
    disableAutoCampaignTypes?: Array<AutomatedCampaignType>,
    onSelect: (bigType: CampaignBigType, automatedType: AutomatedCampaignType) => void,
    onBack: () => void
}

export const dataForAutomationCampaign: Array<SubCampaignTypeItem> = [
    {type: AutomatedCampaignType.appointment, title: "Appointment reminder", description: "Remind your patients before the appointment date.", icon: $iconCalendar},
    {type: AutomatedCampaignType.birthday, title: "Send a birthday message", description: "Send your patient a cheerful message on their birthday.", icon: $iconBirthday},
    {type: AutomatedCampaignType.postAppointment, title: "Post-appointment message", description: "Send a survey or a follow-up message after your patient’s appointment.", icon: $iconPostAppointment},
    // {type: AutomatedCampaignType.appInstallation, title: "iClinicHealth installation message", description: "Introduce the iClinicHealth and public website to your newly registered patients", icon: $iconIClinicHealth},
]

export const dataForCampaignBigType: Array<CampaignBigTypeItem> = [
    {title: "Regular Campaign", description: "Create a campaign, which you can either send now or schedule for later.", bigType: CampaignBigType.regularCampaign, subTypeItems: []},
    {title: "Automated Campaign", description: "Create a campaign, which you can select to send as an automation action.", bigType: CampaignBigType.automatedCampaign, subTypeItems: dataForAutomationCampaign},
]

export default function CampaignBigTypeSelection(props: IProps) {
    const {disableAutoCampaignTypes, onSelect} = props

    const $selectButton = (bigType: CampaignBigType, automatedType: AutomatedCampaignType) => {
        if (disableAutoCampaignTypes?.includes(automatedType)) {
            let tips = ""
            if (automatedType === AutomatedCampaignType.appointment) {
                tips = MaxAppointmentReminderCount > 1 ? `Only ${MaxAppointmentReminderCount} appointment reminder campaigns are allowed.` : `Only ${MaxAppointmentReminderCount} appointment reminder campaign is allowed.`
            } else if (automatedType === AutomatedCampaignType.birthday) {
                tips = MaxBirthdayReminderCount > 1 ? `Only ${MaxBirthdayReminderCount} birthday reminder campaigns are allowed.` : `Only ${MaxBirthdayReminderCount} birthday reminder campaign is allowed.`
            }
            return (
                <ToolTips alignStyle={ToolTipAlign.center} position={ToolTipPosition.top} tips={tips}>
                    <Button onClick={() => {
                        onSelect && onSelect(bigType, automatedType)
                    }} status={ButtonStatus.disabled} >
                        Select
                    </Button>
                </ToolTips>
            )
        }
        return (
            <Button onClick={() => {
                onSelect && onSelect(bigType, automatedType)
            }} status={ButtonStatus.primary} >
                Select
            </Button>
        )
    }

    const $subItem = ({title, description, type, icon}: SubCampaignTypeItem) => {
        return (
            <div key={title} className={"w-full flex flex-row items-center justify-between py-4 px-10 border border-gray-200 shadow-md rounded"}>
                <div className={"flex flex-1 flex-row items-center space-x-10"}>
                    <div className={"flex flex-none"}>
                        {icon}
                    </div>
                    <div className={"flex flex-1 flex-col pr-2"}>
                        <p className={"text-sm font-semibold"}>{title}</p>
                        <p className={"text-xs mt-2 w-full"}>{description}</p>
                    </div>
                </div>
                {$selectButton(CampaignBigType.automatedCampaign, type)}
            </div>
        )
    }

    const $subTypesItems = (subTypeItems: Array<SubCampaignTypeItem>) => {
        return (
            <div className={"w-full flex flex-col space-y-8"}>
                {subTypeItems.map((_item) => {
                    return $subItem(_item)
                })}
            </div>
        )
    }

    const $item = ({title, description, bigType, subTypeItems}: CampaignBigTypeItem) => {
        return (
            <Fragment key={title}>
                <div className={`w-full pr-10 py-4 lg:py-10 flex flex-col lg:flex-row items-start lg:items-center justify-center lg:justify-between bg-white ${subTypeItems && subTypeItems.length ? "" : "border-b"} border-gray-200 space-y-2 lg:space-y-0`}>
                    <div className={"flex-1 "}>
                        <p className={"text-lg text-gray-1 font-bold text-left"}>{title}</p>
                        <p className={"text-sm text-gray-1 mt-2 text-left"}>{description}</p>
                    </div>
                    {subTypeItems && subTypeItems.length ? null : $selectButton(bigType, AutomatedCampaignType.none)}
                </div>
                {subTypeItems && subTypeItems.length ? $subTypesItems(subTypeItems) : null}
            </Fragment>
        )
    }

    const $title = (
        <Fragment>
            <p className={"font-bold text-2xl"}>Campaign Type</p>
            <p className={"text-gray-2 mt-2 font-base text-base"}>Select a type of campaign to send.</p>
            <div className={"w-full h-px bg-gray-300 mt-4"}/>
        </Fragment>
    )

    const $typeList = (dataForCampaignBigType.map((_item) => {
        return $item(_item)
    }))

    return <div className={"w-full p-6 lg:p-10 bg-white shadow-lg rounded-lg"}>
        {$title}
        {$typeList}
    </div>
}
